export const MODULE_NAME = 'Config'

export const paths = {
  accountant: '/config/accountant',
  company: '/config/company',
  subscription: '/config/subscription',
  payment: '/config/payment',
}
